import { render, staticRenderFns } from "./HistoriasClinicasMascotas.vue?vue&type=template&id=822cf34e&scoped=true&"
import script from "./HistoriasClinicasMascotas.vue?vue&type=script&lang=js&"
export * from "./HistoriasClinicasMascotas.vue?vue&type=script&lang=js&"
import style0 from "./HistoriasClinicasMascotas.vue?vue&type=style&index=0&id=822cf34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822cf34e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCard,VCol,VContainer,VFlex,VLayout,VRow,VSnackbar,VTextField})
